/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Select,
  MenuItem,
  SelectChangeEvent,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import CommissionOfferModal from "../../Modals/commissionOffer";
import { useLazyGetWorkQuery } from "../../services/users";
import { showError } from "../../constants/toasts";
import moment from "moment";
import { SKILLS } from "../../utils/enums";
import useTranslation from "../../hooks/traslation";

interface WorkHistoryListProps {
  freelancerId: string;
  debouncedSearchTerm: string;
}

const WorkHistoryList = ({
  freelancerId,
  debouncedSearchTerm,
}: WorkHistoryListProps) => {
  const navigate = useNavigate();
  const [getWork, { isLoading }] = useLazyGetWorkQuery();
  const [workData, setWorkData] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState(0);
  const limit = 10;

  const handlePageChange = (event: any, newPage: number) => {
    const updatedPage = newPage + 1;
    setPage(updatedPage);
  };

  const fetchWorkData = async () => {
    try {
      const response = await getWork({
        id: freelancerId,
        search: debouncedSearchTerm,
        page: page,
        limit: limit,
      }).unwrap();
      if (response?.statusCode === 200) {
        setWorkData(response.data?.list || []);
        setCount(response.data?.totalCount || 0);
      } else {
        setWorkData([]);
        setCount(0);
      }
    } catch (error) {
      showError("Failed to load work history");
      setWorkData([]);
      setCount(0);
    }
  };

  useEffect(() => {
    if (freelancerId) {
      fetchWorkData();
    }
  }, [freelancerId, page, debouncedSearchTerm]);
  const columns: GridColDef[] = [
    {
      flex: 1,
      minWidth: 220,
      field: "employerId",
      headerName: "Employer",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(`/manage-freelancer/work-history/${freelancerId}/${row?._id}`)
            }
          >
            <p>
              <b>{`${row.employerId?.firstName || ""} ${
                row.employerId?.lastName || ""
              }`}</b>
              <span>{row.employerId?.email || ""}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "startTime",
      headerName: "Start Time",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <p>
            <strong>{moment(row.startTime).format("lll")}</strong>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "endTime",
      headerName: "End Time",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <p>
            <strong>{moment(row.endTime).format("lll")}</strong>
          </p>
        );
      },
    },
    {
      minWidth: 150,
      field: "skills",
      headerName: "Skills Used",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p>
            <strong>
              {Array.isArray(row.skills)
                ? row.skills
                    .map((skillId: string) =>
                      Object.keys(SKILLS).find(
                        (key) =>
                          SKILLS[key as keyof typeof SKILLS] === Number(skillId)
                      )
                    )
                    .join(", ")
                : "N/A"}
            </strong>
          </p>
        );
      },
    },
    {
      minWidth: 130,
      field: "action",
      headerName: useTranslation().globals.actions,
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <Tooltip title="View">
                <IconButton
                  onClick={() =>
                    navigate(`/manage-freelancer/work-history/${freelancerId}/${row?._id}`)
                  }
                >
                  <img src="/static/images/eye_icon.svg" alt="View" />
                </IconButton>
              </Tooltip>
            </Box>
          </div>
        );
      },
    },
  ];

  let hidden = ["fullName"];

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={workData}
          loading={isLoading}
          page={page - 1}
          count={count}
          onPageChange={handlePageChange}
        />
      </div>

      <CommissionOfferModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />
      <RejectReasonModal
        open={open1}
        onClose={handleCloseModal1}
        setOpen={setOpen1}
      />
    </>
  );
};

export default WorkHistoryList;
